export interface ShopLocation {
  Name: string;
}

export interface Shop {
  FloristId: string;
  ShopLocation: ShopLocation;
}

export async function getMultiShop(floristId: string): Promise<Shop[]> {
  try {
    const url = `${useMsUrls().pfsBackOffice}/FloristActionsQueries/GetUserShopsList?floristId=${floristId}`;
    const response = await useCustomFetch<Shop[]>(url);
    return response ?? [];
  } catch (error) {
    console.error('getMultiShop error:', error);
    return [];
  }
}
